import React from 'react'
import Testimonial from './testimonial'
import Contactfooter from './contactfooter'
import { Helmet } from 'react-helmet'

const OurWork = () => {
  return (
    <div>
       <Helmet>
        <title>Our Work</title>
        <meta
          name="description"
          content="Krisoft provides top-notch Android development services, creating innovative and user-friendly mobile applications."
        />
        <meta
          name="keywords"
          content="Android development, mobile apps, Krisoft, app development, Android solutions"
        />
      </Helmet>
      <Testimonial/>
      <Contactfooter/>
    </div>
  )
}

export default OurWork
